var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"80px","text-align":"center"}},[_c('p',{class:[_vm.levelClass(3), 'mt-0 mb-0 pt-0 pb-0']},[_vm._v("Pro")]),_c('p',{class:[_vm.levelClass(2), 'mt-0 mb-0 pt-0 pb-0']},[_vm._v("Med")]),_c('p',{class:[_vm.levelClass(1), 'mt-0 mb-0 pt-0 pb-0 ']},[_vm._v("Jr")])])
}
var staticRenderFns = []

export { render, staticRenderFns }